import { Grid } from "@mui/material";

export const OptionSeasonStats = (props) => {
  let statsType = "player";
  if (!props.playerId && !props.teamId) {
    return <></>;
  }
  if (!props.playerId) {
    statsType = "team";
  }
  console.log(props.stats);
  if (statsType === "player") {
    return (
      <Grid container>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          Player Season Stats
        </Grid>
        <Grid item xs={6} sx={{ textAlign: "left" }}>
          Games Played:
          <br />
          Goals:
          <br />
          Assists:
          <br />
          PPG:
          <br />
          Shots:
          <br />
          PIM:
          <br />
        </Grid>
        <Grid item xs={6} sx={{ textAlign: "right" }}>
          {props.stats?.gp === null ? "--" : props.stats?.gp}
          <br />
          {props.stats?.g === null ? "--" : props.stats?.g}
          <br />
          {props.stats?.a === null ? "--" : props.stats?.a}
          <br />
          {props.stats?.ppg === null ? "--" : props.stats?.ppg}
          <br />
          {props.stats?.s === null ? "--" : props.stats?.s}
          <br />
          {props.stats?.pim === null ? "--" : props.stats?.pim}
          <br />
        </Grid>
      </Grid>
    );
  }
  if (statsType === "team") {
    return (
      <Grid container>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          {props.stats.teamName} Season:
        </Grid>
        <Grid item xs={6} sx={{ textAlign: "left" }}>
          Points:
          <br />
          Goals:
          <br />
          PPGoals:
          <br />
        </Grid>
        <Grid item xs={6} sx={{ textAlign: "right" }}>
          {props.stats.stats?.pts === null ? "--" : props.stats.stats?.pts}
          <br />
          {props.stats.stats?.g === null ? "--" : props.stats.stats?.g}
          <br />
          {props.stats.stats?.ppGoalsFor === null
            ? "--"
            : props.stats.stats?.ppGoalsFor}
          <br />
        </Grid>
      </Grid>
    );
  }
};
